const IMAGE_EDIT_EVENTS = [
  'generation-complete', 'grading-updated', 'crop-updated', 'generation-deleted',
  'display-selection-changed', 'image-rotated', 'generation-rotated',
  'image-comment-updated', 'image-frame-updated', 'image-description-updated',
  'image-mask-regions-updated', 'generation-mask-regions-updated',
  'image-moved', 'images-bulk-moved', 'images-reordered',
  'image-uploaded', 'image-deleted', 'images-deleted',
  'image-categorized', 'images-bulk-categorized', 'category-deleted',
];

export function subscribeToImageEdits(on, off, refreshImages) {
  let timer;
  const refresh = () => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      void refreshImages().catch(error => console.error('[RecentEdits] Image refresh failed:', error));
    }, 100);
  };
  IMAGE_EDIT_EVENTS.forEach(event => on(event, refresh));
  return () => {
    clearTimeout(timer);
    IMAGE_EDIT_EVENTS.forEach(event => off(event, refresh));
  };
}
